export type RefLike<T> = { current: T };

export function pickLoanField(record: any, keys: string[]) {
  if (!record) return null;
  return keys.reduce((found, key) => found || record[key], null);
}

export function getExcelRowForDrawId(drawId: string) {
  try {
    const stored = sessionStorage.getItem("drawExcelUpload");
    if (!stored) return null;
    const rows = JSON.parse(stored);
    if (!Array.isArray(rows)) return null;
    return (
      rows.find((row: any) => String(row?.drawId) === String(drawId)) ?? null
    );
  } catch {
    // Invalid or unreadable drawExcelUpload JSON; continue without an Excel row.
    return null;
  }
}

export function matchLoanFromAvailableList(loanIds: any[], primaryLoanId: any) {
  return loanIds?.find((loan: any) => {
    const primaryFromList = pickLoanField(loan, [
      "primaryLoanId",
      "primary_loan_id",
      "primaryloanid"
    ]);
    return (
      primaryFromList &&
      primaryLoanId &&
      primaryFromList.toString() === primaryLoanId.toString()
    );
  });
}

export function resolveEffectiveToorakLoanId(
  drawDetails: any,
  loanIds: any[],
  drawId: string,
  bulkDraw: boolean
) {
  const matchedLoan = matchLoanFromAvailableList(
    loanIds,
    drawDetails?.primaryLoanId
  );
  const excelRow = bulkDraw && drawId ? getExcelRowForDrawId(drawId) : null;
  const toorakKeys = ["toorakLoanId", "toorak_loan_id", "toorakloanid"];
  return (
    drawDetails?.toorakLoanId ||
    pickLoanField(matchedLoan, toorakKeys) ||
    pickLoanField(excelRow, toorakKeys) ||
    null
  );
}

export function shouldHandleMissingPropertyDetails(
  bulkDraw: boolean,
  drawDetails: any,
  isInDraftStage: boolean
) {
  return (
    !bulkDraw &&
    Boolean(drawDetails?.primaryLoanId) &&
    !drawDetails.propertyDetails?.length &&
    isInDraftStage
  );
}

export function shouldFetchDraftLoanDetails(params: {
  drawId: string;
  drawDetails: any;
  effectiveToorakLoanId: string | null;
  prevDrawIdRef: RefLike<string | null>;
  lastLoanDetailsRequestRef: RefLike<{
    drawId: string;
    toorakLoanId: string;
  } | null>;
}) {
  const {
    drawId,
    drawDetails,
    effectiveToorakLoanId,
    prevDrawIdRef,
    lastLoanDetailsRequestRef
  } = params;
  if (!drawId || !drawDetails?.primaryLoanId || !effectiveToorakLoanId) {
    return false;
  }
  const drawDetailsMatchUrl =
    !drawDetails?.drawId || String(drawDetails.drawId) === String(drawId);
  if (!drawDetailsMatchUrl) return false;
  if (prevDrawIdRef.current !== drawId) {
    prevDrawIdRef.current = drawId;
    lastLoanDetailsRequestRef.current = null;
  }
  const requestKey = `${drawId}|${effectiveToorakLoanId}`;
  const lastKey = lastLoanDetailsRequestRef.current
    ? `${lastLoanDetailsRequestRef.current.drawId}|${lastLoanDetailsRequestRef.current.toorakLoanId}`
    : null;
  if (lastKey === requestKey) return false;
  lastLoanDetailsRequestRef.current = {
    drawId,
    toorakLoanId: effectiveToorakLoanId
  };
  return true;
}
